import styled from 'styled-components';

export const Wrapper = styled.div`
    font-size: 1.5rem;
    margin: 0 0 0 60px;
    border-left: 1px solid #ccc;
    padding: 0 0 0 30px;

    @media (max-width: 1440px) {
        margin: 0 0 0 45px;
        border-left: none;
        padding: 0 0 0 15px;
    }
`;

export const SettingsPanelWrapper = styled.div`
    flex: 0 0 auto;
    max-width: 30%;
    position: relative;
    margin-top: 4px;
    input[type='checkbox'] {
        margin-right: 5px;
    }
`;

export const SelectVesselWrapper = styled.div`
    display: flex;
    align-content: center;
    justify-content: center;
    font-size: 0.8rem;
    margin-right: 20px;
    box-shadow: 0 1px 10px -2px #ccc;
    height: 30px;
    padding: 0px 3px;

    .react-select__control--is-focused {
        .react-select__indicators {
            .react-select__indicator {
                padding: 2px !important;
                height: 30px;
                &:hover {
                    padding: 2px !important;
                }
            }
            padding: 2px !important;
            height: 30px;
            &:hover {
                padding: 2px !important;
            }
        }
    }

    .css-1nmdiq5-menu {
        z-index: 11;
    }

    .react-select__indicators {
        padding: 2px !important;
        height: 32px;
        &:hover {
            padding: 2px !important;
        }
    }

    .css-1xc3v61-indicatorContainer {
        padding: 2px !important;
        height: 30px !important;
        &:hover {
            padding: 2px !important;
        }
    }
`;

export const PanelSettingsButton = styled.div`
    button {
        height: 30px;
        width: 30px;
    }
`;
